import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { SymbolMappingFilterParam } from '../_helpers/symbolMappingFilterSearchParam';
import { SymbolMappingFilterAction } from '../symbolMappingFilter.action';

type IState = IGetSelectorStateType<typeof queryParamSelector>;

export const setSymbolMappingFilterEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolMappingFilterAction.setFilter),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const currentFilter = queryParamSelector(state, SymbolMappingFilterParam.name);

    if (payload === currentFilter) {
      return [RouterAction.removeParam(SymbolMappingFilterParam.name)];
    }
    return [RouterAction.addParam(SymbolMappingFilterParam.nameAndValue(payload))];
  }),
);
